import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { AESEncryptJSON } from "../../../../utils/encryption/AESEncrypt";
import { avatarGenerator } from "../../../../utils/generator";

const persistConfig = {
  key: `__auth_`,
  storage,
  version: 1,
};

const initialState = {
  isAuthenticated: false,
  isInitialised: false,
  data: undefined,
};

export const AuthData = persistReducer(
  persistConfig,
  (state = initialState, action) => {
    switch (action.type) {
      case "SIGN_IN":
      case "SAVE_USER_DATA": {
        const concatData = Object.assign(action.payload.data, {
          avatar: avatarGenerator(action.payload.data?.nama_lengkap),
          role: action.payload.data.role.toUpperCase(),
        });
        return {
          isAuthenticated: true,
          isInitialised: true,
          data: AESEncryptJSON(concatData) ?? undefined,
        };
      }
      case "SIGN_UP":
      case "SIGN_OUT": {
        return {
          isAuthenticated: false,
          isInitialised: false,
          data: undefined,
        };
      }
      default:
        return state;
    }
  }
);
